import { differenceInCalendarDays, parseISO } from "date-fns";

export function getDaysUntil(dateString: string): number {
    const dueDate = parseISO(dateString);
    const today = new Date();

    return differenceInCalendarDays(dueDate, today);
}
